// Tables2.0.js
// Base UI for the Tables section — no modals.
// The "Demo Reservations" button opens the reservation-booking widget,
// loaded from the same URL any restaurant site would use.
import React, { useEffect, useRef } from 'react';
import { motion } from 'framer-motion';
import { servicesData } from '../data';
import { staggerContainer, fadeIn } from '../variants';
import tablesGraphic from '../../src/assets/img/tables/3dtables1.png';

const WIDGET_SRC = 'https://gohost-b65d2.web.app/widgets/reservation-booking.js';
const RESTAURANT_ID = 'thaicoon';

const TableFeature = ({ headerRef }) => {
  const { pretitle, title, subtitle, subtitle2 } = servicesData;
  const scriptRef = useRef(null);

  // Load the widget script once — exactly how any restaurant site would add it.
  // Using the production URL means this tests the real deployed artifact.
  useEffect(() => {
    if (document.getElementById('gh-booking-widget-script')) return; // already loaded

    const script = document.createElement('script');
    script.id = 'gh-booking-widget-script';
    script.src = WIDGET_SRC;
    script.setAttribute('data-restaurant-id', RESTAURANT_ID);
    script.defer = true;
    document.body.appendChild(script);
    scriptRef.current = script;

    return () => {
      // Clean up if component unmounts (dev only — fine to leave in prod)
      script.remove();
    };
  }, []);

  function handleDemoClick() {
    if (window.GoHostBooking) {
      window.GoHostBooking.open({ restaurantId: RESTAURANT_ID });
    } else {
      console.warn('[Tables2.0] GoHostBooking widget not loaded yet');
    }
  }

  return (
    <div>
      <section className='select-none min-h-[700px] bg-gradient-to-b from-neutral-700 to-white-100/20 pb-[150px]'>
        <div className='container mx-auto min-h-[620px]'>
          <motion.div
            variants={staggerContainer}
            initial='hidden'
            whileInView={'show'}
            viewport={{ once: false, amount: 0.1 }}
            className='min-h-[620px] flex flex-col lg:flex-row items-center justify-center'
          >
            <motion.div
              variants={fadeIn('down', 'spring', 0.1, 1.2)}
              className='flex-1 text-center lg:text-center p-2 mt-[200px]'
            >
              <div className='pretitle text-[#ead05a] sm:text-[16px] -mt-4'>Have a Bite</div>
              <h2 className='-mt-2 h2 text-[#f9f9e1] capitalize'>Seat it for Yourself</h2>
              <p className='-mt-2 max-w-[600px] text-neutral-900 mx-auto xl:text-[22px]' style={{ textShadow: '0 0 8px rgba(255,255,255,0.6), 0 0 18px rgba(255,255,255,0.3)' }}>
                See what your customers will see!
              </p>
              <p className='max-w-[600px] text-neutral-900 mx-auto xl:text-[20px]' style={{ textShadow: '0 0 8px rgba(255,255,255,0.6), 0 0 18px rgba(255,255,255,0.3)' }}>
                With GoHost, you introduce an exclusive and personalized feel through precise user
                mapping of time and table for their dining experience
              </p>
              <div className='-mt-14 flex justify-center'>
                <img
                  src={tablesGraphic}
                  alt='Tables Graphic'
                  className='mt-14 mb-10'
                  style={{ maxWidth: '300px' }}
                />
              </div>
              <button
                className='btn capitalize mx-auto -mt-16 mb-4'
                onClick={handleDemoClick}
              >
                Demo Reservations
              </button>
            </motion.div>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default TableFeature;
